import Iframe from "react-iframe";
import Menu from "../Menu/Menu";
import FormHeader from "../PersonalData/FormHeader";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import useStyles from "../../assets/styles/styles";
import { handleGoToPersonalData } from "../../utils/utilsFunctions";

const PersonalDataFrequentQuestions = () => {
    const { screen } = useResizeScreen();
    const classes = useStyles();
    return (
        <>
            <Menu />
            {
                screen.sWidth < 768 &&
                <FormHeader title={"Preguntas Frecuentes"} handleGoTo={handleGoToPersonalData} />
            }
            <div className={classes.Redirect} style={{marginLeft: "-8px", marginTop: "-10px"}}>
                <Iframe sandbox='' scrolling="yes" src='https://www.oslpasteur.com.ar/PortalHTML5/accesos/PreguntasFrecuentes/index.html?afiliacion'
                    className={classes.iframe} />
            </div>

        </>
    );
};

export default PersonalDataFrequentQuestions;
